var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFaq(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.704,
    height: 20.668,
    viewBox: "0 0 15.704 20.668",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3169",
    "data-name": "Group 3169",
    transform: "translate(-216.5 -458.056)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_85842",
    "data-name": "Path 85842",
    d: "M144.125,210.188V221.5H130.049V200.834H144.12V203Zm-12.541,9.255h11V206.3h-11Z",
    transform: "translate(88.079 257.222)",
    fill: "#0094d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85844",
    "data-name": "Path 85844",
    d: "M92.052,236.8h1.136v17.839H92.052Z",
    transform: "translate(124.448 222.798)",
    fill: "#0094d9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3168",
    "data-name": "Group 3168"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_85854",
    "data-name": "Path 85854",
    d: "M176,502.684h4.8v2.388h-.224c-1.449,0-2.9,0-4.346,0-.2,0-.252-.06-.248-.253.011-.642,0-1.284,0-1.927C175.99,502.833,176,502.77,176,502.684Z",
    transform: "translate(44.11 -31.696)",
    fill: "#0094d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85959",
    "data-name": "Path 85959",
    d: "M176,502.684h4.8v2.388h-.224c-1.449,0-2.9,0-4.346,0-.2,0-.252-.06-.248-.253.011-.642,0-1.284,0-1.927C175.99,502.833,176,502.77,176,502.684Z",
    transform: "translate(44.11 -37.413)",
    fill: "#0094d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85855",
    "data-name": "Path 85855",
    d: "M304.635,505.164H299.85v-2.37h4.785Z",
    transform: "translate(-74.447 -31.801)",
    fill: "#0094d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85960",
    "data-name": "Path 85960",
    d: "M304.635,505.164H299.85v-2.37h4.785Z",
    transform: "translate(-74.447 -37.518)",
    fill: "#0094d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85856",
    "data-name": "Path 85856",
    d: "M180.788,571.514c-.074.005-.136.013-.2.013-1.456,0-2.912,0-4.368,0-.194,0-.257-.049-.253-.249.012-.649.006-1.3,0-1.948,0-.119.006-.2.166-.2,1.52,0,3.04,0,4.56,0a.562.562,0,0,1,.09.016Z",
    transform: "translate(44.127 -95.298)",
    fill: "#0094d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85958",
    "data-name": "Path 85958",
    d: "M180.788,571.514c-.074.005-.136.013-.2.013-1.456,0-2.912,0-4.368,0-.194,0-.257-.049-.253-.249.012-.649.006-1.3,0-1.948,0-.119.006-.2.166-.2,1.52,0,3.04,0,4.56,0a.562.562,0,0,1,.09.016Z",
    transform: "translate(44.127 -101.015)",
    fill: "#0094d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85857",
    "data-name": "Path 85857",
    d: "M304.654,572.029h-4.787V569.67h4.787Z",
    transform: "translate(-74.464 -95.812)",
    fill: "#0094d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85957",
    "data-name": "Path 85957",
    d: "M304.654,572.029h-4.787V569.67h4.787Z",
    transform: "translate(-74.464 -101.529)",
    fill: "#0094d9"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaq);
export default __webpack_public_path__ + "static/media/faq.1652b19fe43bb2f14fba330b03987a38.svg";
export { ForwardRef as ReactComponent };